export default __webpack_public_path__ + "static/32-a8e22212c99bb829d2c04fadaf350a15.jpg";